import { type SectionActions, sectionActions } from '@capsicum/common';

export function isASectionAction(action: string): action is SectionActions {
	return sectionActions.includes(action);
}
